import ZoomOut from './src/zoom-out-combined';
export default ZoomOut;